// Organizations Controller
// Handles organization-related operations

import { post } from './utilitiesController.js';

/**
 * Add a new organization based on provided data
 * @param {Object} data - Data for the new organization
 * @returns {Object|null} - Created organization object or null if failed
 */
export const addOrganization = async (data) => {
    // TODO: Implement organization creation logic
    // This function will contain the logic to create a new organization
    // based on the provided data parameter

    const response = await post('api/org/create', data, true);
    return response.data;
};

/**
 * Get list of organizations
 * @param {Object} params - Query parameters for pagination (page, limit)
 * @returns {Promise} - Response from organizations list endpoint
 */
export const getOrganizations = async (params = {}) => {
    try {
        const response = await post('api/org/list', params, true);
        return response;
    } catch (error) {
        console.error('Failed to fetch organizations:', error);
        throw error;
    }
};

/**
 * Get specific organization details
 * @param {string} organizationId - ID of the organization to fetch
 * @returns {Promise} - Response from organization details endpoint
 */
export const getOrganization = async (data) => {
    try {
        const organizationId = data.organization_id;
        const requestBody = { id: organizationId };
        console.log('Making API call to get organization:', `api/org/get_organization/${organizationId}`);
        console.log('Request body being sent:', requestBody);
        
        const response = await post(`api/org/get_organization/${organizationId}`, requestBody, true);
        console.log('API response received:', response);
        return response;
    } catch (error) {
        console.error('Failed to get organization:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
    }
};

/**
 * Update an organization
 * @param {Object} data - Data containing organization_id and updated fields (name, type)
 * @returns {Promise} - Response from organization update endpoint
 */
export const updateOrganization = async (data) => {
    console.log('Updating organization:', data);
    try {
        const organizationId = data.organization_id;
        // Create request body with organization_id, name, and type
        const requestData = {
            organization_id: organizationId,
            name: data.name,
            type: data.type
        };
        
        console.log('Making API call to update organization:', `api/org/edit_organization/${organizationId}`);
        console.log('Request body being sent:', requestData);
        
        const response = await post(`api/org/edit_organization/${organizationId}`, requestData, true);
        console.log('API response received:', response);
        return response;
    } catch (error) {
        console.error('Failed to update organization:', error);
        console.error('Error details:', error.response?.data || error.message);
        throw error;
    }
};

export default {
    addOrganization,
    getOrganizations,
    getOrganization,
    updateOrganization
};
